<template lang="pug">
    div
        // wafRuleList.rules[index]
        FormItem(
                v-for="field in ruleFields(this)"
                :key="field.key"
                :label="field.label"
                :prop="propPrefix + '.' + field.key"
                :rules="field.vShowFieldVal(value)==1 ? field.validate : []"
                v-if="field.vShowFieldVal(value)==1"
            )
            component(
                :is="field.formRender"
                v-model="value[field.key]"
                :formData="formData"
                :formItem="field"
                v-bind="field.extraProps"
            )
</template>
<script>
import ruleFields from "./ruleFields.js";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import FormSwitch from "@/components/rcmTableFormItems/Switch";
import WafSegmentBuilder from "@/components/FormItems/WafSegmentBuilder.vue";
import FormInputNumber from "@/components/rcmTableFormItems/InputNumber";
import WafRateLimitTokenForm from "@/components/FormItems/WafRateLimitTokenForm";
import WafRedirectUrlBuilder from "@/components/FormItems/WafRedirectUrlBuilder.vue";
import FormInput from "@/components/rcmTableFormItems/Input.vue";

export default {
    name: "rules",
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        formData: {},
        formItem: {},
        propPrefix: {
            type: String,
            default: () => "",
        },
        groupName: {
            type: String,
            default: () => "",
        },
    },
    components: {
        FormSelect,
        FormSwitch,
        WafSegmentBuilder,
        FormInputNumber,
        WafRateLimitTokenForm,
        WafRedirectUrlBuilder,
        FormInput,
    },
    data() {
        return {};
    },
    methods: {
        ruleFields,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/wafRuleList/rule.vue